<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
  <ng-container *ngFor="let view of viewKinds; let index=index">
    <input type="radio" class="btn-check" name="vbtn-radio" [id]="'vbtn-radio'+index" autocomplete="off"
      [attr.checked]="ctx.ViewKind === view.kind?'':null">
    <label class="btn btn-outline-secondary" [for]="'vbtn-radio'+index" tooltip="{{view.info}}" placement="bottom"
      container="body" (click)="changeViewKind(view.kind)"><i [ngClass]="view.icon"></i></label>
  </ng-container>
</div>